var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { InfluencerGroupNew, InfluencerGroup } from '../../../../models/influencer-group';
import { InfluencerGroupsService } from '../influencer-groups.service';
import { UserService } from '../../../services/user.service';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { PlaceholderVisibilityService } from '../../../services/placeholder-visibility/placeholder-visibility.service';
import { CommonConstant } from '../../../app.constants';
import { EventTrackerService, Page, UserActionType, ActivePages, ActionSource } from '../../../services/event-tracker/event-tracker.service';
import { ActivePage } from '../../../../models/event-tracker';
import { ValidationHandlerService } from '../../../core/validation-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { GroupService } from '../../../services/group-details/group.service';
import { ObjectUtils } from '../../../utils/object.utils';
var CreateGroupFragmentComponent = /** @class */ (function () {
    function CreateGroupFragmentComponent(influenderGroupsService, userService, referenceDataService, placeholderVisibilityService, validationService, eventTracker, translate, groupService) {
        this.influenderGroupsService = influenderGroupsService;
        this.userService = userService;
        this.referenceDataService = referenceDataService;
        this.placeholderVisibilityService = placeholderVisibilityService;
        this.validationService = validationService;
        this.eventTracker = eventTracker;
        this.translate = translate;
        this.groupService = groupService;
        this.cancelCreateOrUpdateGroupEvent = new EventEmitter();
        this.beforeCreateOrUpdateGroupEvent = new EventEmitter();
        this.afterCreateOrUpdateGroupEvent = new EventEmitter();
    }
    CreateGroupFragmentComponent.prototype.ngOnInit = function () {
        if (this.groupNeedToUpdate) {
            this.loadInfluencerGroupDetail();
        }
    };
    CreateGroupFragmentComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var textarea = document.querySelector('.desc-field textarea');
        textarea.addEventListener('keyup', function () {
            textarea.style.height = _this.calcHeight(textarea.value) + 'px';
        });
    };
    CreateGroupFragmentComponent.prototype.loadInfluencerGroupDetail = function () {
        this.previousInfluencerGroupDetail = this.groupNeedToUpdate ? ObjectUtils.deepClone(this.groupNeedToUpdate) : null;
        this.groupName = this.groupNeedToUpdate ? this.groupNeedToUpdate.influencer_group_name : null;
        this.groupDescription = this.groupNeedToUpdate ? this.groupNeedToUpdate.influencer_group_description : null;
    };
    CreateGroupFragmentComponent.prototype.createOrUpdateGroup = function () {
        if (this.groupNeedToUpdate) {
            this.updateGroup();
        }
        else {
            this.createNewGroup();
        }
    };
    CreateGroupFragmentComponent.prototype.updateGroup = function () {
        var _this = this;
        var influencerGroupData = {
            companyId: this.userService.getCompanyId(),
            influencerGroupDescription: this.groupDescription,
            influencerGroupId: this.groupNeedToUpdate.influencer_group_id,
            influencerGroupName: this.groupName,
            influencerGroupType: this.groupNeedToUpdate.influencer_group_type,
            conditionListObject: this.groupService.normalizeGroupConditionList(this.groupNeedToUpdate.condition_list_object),
            influencerGroupTypeValues: this.groupNeedToUpdate.influencer_group_type_values
        };
        var errors = this.influenderGroupsService.validateGroup(influencerGroupData);
        if (errors && errors.length > 0) {
            this.validationService.shouldDisplayErrors(true);
            this.validationService.updateErrors(errors);
            return;
        }
        // optimistic UI, update group name and close bottombar
        this.beforeCreateOrUpdateGroupEvent.emit(influencerGroupData);
        this.groupService.updateInfluencerGroup(influencerGroupData).subscribe(function (res) {
            _this.afterCreateOrUpdateGroupEvent.emit({
                isError: false,
                data: influencerGroupData
            });
        }, function (error) {
            _this.afterCreateOrUpdateGroupEvent.emit({
                isError: true,
                data: error
            });
            _this.loadInfluencerGroupDetail();
        });
    };
    /**
     * everytime create a group successfully. We must register it to segment
     * @param {InfluencerGroupNew} influencerGroup
     */
    CreateGroupFragmentComponent.prototype.sendEventToSegmentAfterCreatingGroupSuccess = function (influencerGroup) {
        var _this = this;
        this.influenderGroupsService.getInfluencerGroups(this.userService.getCompanyId()).subscribe(function (data) {
            var newGroup;
            if (data && Array.isArray(data)) {
                newGroup = data.find(function (g) { return g.name === influencerGroup.influencerGroupName; });
            }
            if (newGroup) {
                // track event to Segment
                _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
                    id: newGroup.id,
                    name: newGroup.name,
                    type: Page.GROUP
                }, __assign({ action: UserActionType.CREATE, source: ActionSource.ACTION_VIEW }, influencerGroup), undefined, {
                    type: _this.activePage && _this.activePage.type || ActivePages.DISCOVER,
                    name: _this.activePage && _this.activePage.name,
                    id: _this.activePage && _this.activePage.id
                });
                _this.eventTracker.trackUserAction(UserActionType.CHAM_GROUP_CREATE);
            }
        });
    };
    CreateGroupFragmentComponent.prototype.createNewGroup = function () {
        var _this = this;
        var influencerGroup = this.prepareNewGroupData();
        var errors = this.influenderGroupsService.validateGroup(influencerGroup);
        if (errors && errors.length > 0) {
            this.validationService.shouldDisplayErrors(true);
            this.validationService.updateErrors(errors);
            return;
        }
        this.beforeCreateOrUpdateGroupEvent.emit({
            data: {
                id: influencerGroup.influencerGroupId,
                name: this.groupName,
                description: this.groupDescription
            },
            isCreated: true
        });
        // show loader
        this.placeholderVisibilityService.show(CommonConstant.CREATE_NEW_GROUP_HOLDER);
        this.influenderGroupsService.createInfluencerGroup(influencerGroup).subscribe(function (data) {
            // execute callback after creating new group
            _this.afterCreateOrUpdateGroupEvent.emit({
                data: {
                    name: _this.groupName,
                    description: _this.groupDescription
                },
                isCreated: true,
                isError: false
            });
            _this.sendEventToSegmentAfterCreatingGroupSuccess(influencerGroup);
            // reset ngModel data
            _this.groupName = null;
            _this.groupDescription = null;
            // hide loader
            _this.placeholderVisibilityService.hide(CommonConstant.CREATE_NEW_GROUP_HOLDER);
        }, function (error) {
            _this.afterCreateOrUpdateGroupEvent.emit({
                data: {
                    name: _this.groupName,
                    description: _this.groupDescription
                },
                isCreated: true,
                isError: true
            });
            _this.placeholderVisibilityService.hide(CommonConstant.CREATE_NEW_GROUP_HOLDER);
        });
    };
    CreateGroupFragmentComponent.prototype.prepareNewGroupData = function () {
        var influencerGroupType = CommonConstant.PREFERRED_INFLUENCER;
        var influencerGroupNew = new InfluencerGroupNew();
        influencerGroupNew.influencerGroupId = null;
        influencerGroupNew.influencerGroupName = this.groupName;
        influencerGroupNew.influencerGroupType = influencerGroupType;
        influencerGroupNew.influencerGroupDescription = this.groupDescription;
        influencerGroupNew.companyId = this.userService.getCompanyId();
        influencerGroupNew.menuvisible = CommonConstant.DEFAULT_MENU_VISIBLE;
        return influencerGroupNew;
    };
    CreateGroupFragmentComponent.prototype.cancelCreateOrUpdateGroup = function () {
        this.cancelCreateOrUpdateGroupEvent.emit();
    };
    Object.defineProperty(CreateGroupFragmentComponent.prototype, "saveGroupButtonLabel", {
        get: function () {
            return this.groupNeedToUpdate ? this.translate.instant('common.btn.update_group') : this.translate.instant('common.btn.create_new_group');
        },
        enumerable: true,
        configurable: true
    });
    // Dealing with Textarea Height
    CreateGroupFragmentComponent.prototype.calcHeight = function (value) {
        var numberOfLineBreaks = (value.match(/\n/g) || []).length;
        // min-height + lines x line-height + padding + border
        var newHeight = 25 + numberOfLineBreaks * 25;
        return newHeight;
    };
    return CreateGroupFragmentComponent;
}());
export { CreateGroupFragmentComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/create-group-fragment/create-group-fragment.component.ts.pre-build-optimizer.js